import { useFormikContext } from "formik";
import { SelectAutofillCombobox } from "components/SelectAutofillCombobox";
import { AddressAutofill } from "types/Models/addressAutofill";
import { BankAutofill } from "types/Models/bankAutofill";
import { DirectorAutofill } from "types/Models/directorAutofill";
import { PersonaAutofill } from "types/Models/personaAutofill";
import { CustomField } from "../customField.types";
import { OnLabelResolved } from "../customFieldSelector.types";

type AutofillSelectorFieldProps = {
  field: CustomField;
  name: string;
  autofillType: "authorized_persons" | "addresses";
  entityFieldName?: string;
  entityIdFromProps?: string;
  groupId: string;
  disabled?: boolean;
  onLabelResolved?: OnLabelResolved;
};

export const AutofillSelectorField = ({
  field,
  name,
  autofillType,
  entityFieldName,
  entityIdFromProps,
  groupId,
  disabled,
  onLabelResolved,
}: AutofillSelectorFieldProps) => {
  const { values, setFieldValue } = useFormikContext<Record<string, string>>();
  const entityId =
    (entityFieldName && values[entityFieldName]) || entityIdFromProps || "";

  const handleChange = (uuid: string) => setFieldValue(name, uuid);
  const handleSelect = (
    autofill:
      | AddressAutofill
      | BankAutofill
      | PersonaAutofill
      | DirectorAutofill
  ) => {
    if ("autofill_string" in autofill) {
      onLabelResolved?.(name, autofill.autofill_string);
    }
  };

  return (
    <SelectAutofillCombobox
      type={autofillType}
      entityId={entityId}
      groupId={groupId}
      name={name}
      label={field.label}
      placeholder={field.placeholder}
      required={field.is_required}
      selected={values[name]}
      onChange={handleChange}
      onSelect={handleSelect}
      canAddMore={!disabled && Boolean(entityId)}
      isDisabled={disabled}
    />
  );
};
